import React from 'react'
import { FiHeadphones } from '@react-icons/all-files/fi/FiHeadphones'
import { FiMail } from '@react-icons/all-files/fi/FiMail'
import { FiPhone } from '@react-icons/all-files/fi/FiPhone'
import Action from '../primitives/Action'
import styles from './CatalogHelp.module.scss'

const CatalogHelp = ({
  ariaLabel = 'Speaker rental assistance',
  description = 'Our audio team can help you compare coverage, connectivity, pickup, and delivery.',
  heading = 'Not sure which speaker fits your event?',
  onQuote,
  onCall,
  phone = '305 974 4411',
  phoneHref = 'tel:+13059744411',
  quoteLabel = 'Ask an Expert',
  quoteConversionKey,
  callConversionKey,
  conversionLocation = 'catalog-help'
}) => (
  <aside className={styles.help} aria-label={ariaLabel}>
    <span className={styles.icon}><FiHeadphones aria-hidden='true' /></span>
    <div className={styles.copy}>
      <strong>{heading}</strong>
      <span>{description}</span>
    </div>
    <div className={styles.actions}>
      <Action
        variant='secondary'
        size='compact'
        icon={FiMail}
        onClick={onQuote}
        dataConversionKey={quoteConversionKey}
        dataConversionChannel='quote'
        dataConversionLocation={conversionLocation}
        dataConversionSalesPath='managed'
      >
        {quoteLabel}
      </Action>
      <Action
        variant='quiet'
        size='compact'
        icon={FiPhone}
        href={phoneHref}
        onClick={onCall}
        dataConversionKey={callConversionKey}
        dataConversionChannel='phone'
        dataConversionLocation={conversionLocation}
        dataConversionSalesPath='managed'
      >
        {phone}
      </Action>
    </div>
  </aside>
)

export default CatalogHelp
